module.exports = __webpack_public_path__ + "img/btn-cart-date.bcac5f88.svg";